var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-avatar", class: { profile: _vm.isProfileAvatar } },
    [
      _c(
        "div",
        {
          staticClass: "avatar-wrapper",
          style: { background: _vm.avatarColor },
        },
        [
          !_vm.userIcon
            ? _c("avatar", {
                attrs: {
                  username: _vm.userName,
                  backgroundColor: _vm.avatarColor,
                },
              })
            : _c("div", { staticClass: "user-icon" }, [
                _c("img", { attrs: { src: _vm.userIcon } }),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticClass: "user-name" }, [_vm._v(_vm._s(_vm.userName))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }